import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=44f53c78&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f53c78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f53c78')) {
      api.createRecord('44f53c78', component.options)
    } else {
      api.reload('44f53c78', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=44f53c78&scoped=true&", function () {
      api.rerender('44f53c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cguVsQb4fy2B/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports